import React, { useState, useEffect } from "react";
import "./TitleSection.css";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { BsClipboard, BsClipboardCheck } from "react-icons/bs";

const DevelopTitle = () => {
  return (
    <div className="title-section">
      <div className="line fade-blue"></div>
      <div className="circle-section">
        <span className="circle blue">1</span>
        <h3 className="section-label">
          <span className="section-label-text blue">About</span>
        </h3>
      </div>
      <h4 className="section-title" id="develop">
        Start the Development
      </h4>
      <div className="section-content">
        <div className="content-item">
          <p>
            Build your website and app using the latest technologies that are
            used by the big tech companies.
          </p>
        </div>
        <div className="content-item right-item">
          <p>
            Develop and deploy your app from the ground up. Uses frontend best
            practices to deliver great user experience.
          </p>
        </div>
      </div>
    </div>
  );
};

export const WorksTitle = () => {
  return (
    <div className="title-section">
      <div className="line fade-violet"></div>
      <div className="circle-section">
        <span className="circle violet">2</span>
        <h3 className="section-label">
          <span className="section-label-text violet">Works</span>
        </h3>
      </div>
      <h4 className="section-title" id="develop">
        Deploy your App
      </h4>
    </div>
  );
};

export const ContactTitle = () => {
  const [isEmailCopied, setIsEmailCopied] = useState(false);
  const [isPhoneCopied, setIsPhoneCopied] = useState(false);

  const handleEmailCopy = () => {
    setIsEmailCopied(true);
  };

  const handlePhoneCopy = () => {
    setIsPhoneCopied(true);
  };

  useEffect(() => {
    setTimeout(() => {
      if (isEmailCopied) setIsEmailCopied(false);
    }, 2000);
  }, [isEmailCopied]);

  useEffect(() => {
    setTimeout(() => {
      if (isPhoneCopied) setIsPhoneCopied(false);
    }, 2000);
  }, [isPhoneCopied]);

  return (
    <div className="title-section">
      <div className="line fade-orange"></div>
      <div className="circle-section">
        <span className="circle orange">3</span>
        <h3 className="section-label">
          <span className="section-label-text orange">Contact</span>
        </h3>
      </div>
      {/* <h4 className="section-title" id="develop">
        Collaborate
      </h4> */}
      <div className="section-contact">
        <div className="contact-item">
          <CopyToClipboard
            text="sayosaolrak@gmail.com"
            className={`copy-contact ${isEmailCopied ? "copied" : ""}`}
            onCopy={handleEmailCopy}
          >
            <p>
              Email: sayosaolrak@gmail.com{" "}
              <BsClipboard className="clipboard" />{" "}
              <BsClipboardCheck className="clipboard-copied" />
            </p>
          </CopyToClipboard>
        </div>
        <div className="contact-item">
          <CopyToClipboard
            text="+639772503380"
            className={`copy-contact ${isPhoneCopied ? "copied" : ""}`}
            onCopy={handlePhoneCopy}
          >
            <p>
              Phone: (+63) 9772503380 <BsClipboard className="clipboard" />{" "}
              <BsClipboardCheck className="clipboard-copied" />
            </p>
          </CopyToClipboard>
        </div>
      </div>
    </div>
  );
};

export default DevelopTitle;
